/* JALU SMART SEARCH - part 3 of 3 (portable module)
   Searches products by their scent-profile metafield values AND
   product titles (fields specified in sections/jalu-search-index.liquid).
   Dropdown: compact rows. Search page: mini product cards that
   replace the theme's native results (hidden to avoid duplicates;
   restored automatically when the module has no matches).

   JALU_INDEX_VERSION: bump this after bulk catalog changes. It is
   part of both the localStorage cache key AND the section fetch URL,
   so bumping it busts browser caches and Shopify's CDN cache of the
   section-render responses in one go. */

(function () {
  'use strict';

  var JALU_INDEX_VERSION = 5;

  var CONFIG = {
    collectionUrl: '/collections/all',
    sectionId: 'jalu-search-index',
    minChars: 3,
    maxDropdown: 6,
    cacheKey: 'jaluSearchData_v' + JALU_INDEX_VERSION,
    cacheTtlMs: 6 * 60 * 60 * 1000
  };

  var index = null;
  var loading = null;

  function fetchPage(page) {
    return fetch(CONFIG.collectionUrl + '?section_id=' + CONFIG.sectionId + '&jv=' + JALU_INDEX_VERSION + '&page=' + page)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-jalu-search-index]');
        return el ? JSON.parse(el.textContent) : null;
      });
  }

  function loadIndex() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    try {
      var cached = localStorage.getItem(CONFIG.cacheKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (Date.now() - parsed.ts < CONFIG.cacheTtlMs) {
          index = parsed.products;
          try { window.jaluSearchIndexSize = index.length; } catch (e) { /* ignore */ }
          return Promise.resolve(index);
        }
      }
    } catch (e) { /* ignore */ }

    loading = fetchPage(1).then(function (first) {
      if (!first) return null;
      var pagePromises = [];
      for (var p = 2; p <= first.pages; p++) {
        pagePromises.push(fetchPage(p));
      }
      return Promise.all(pagePromises).then(function (rest) {
        var products = first.products;
        rest.forEach(function (pg) {
          if (pg && pg.products) products = products.concat(pg.products);
        });
        index = products;
        try { window.jaluSearchIndexSize = index.length; } catch (e) { /* ignore */ }
        try {
          localStorage.setItem(CONFIG.cacheKey, JSON.stringify({ ts: Date.now(), products: products }));
        } catch (e) { /* storage full - run uncached */ }
        return index;
      });
    }).catch(function () { return null; }).finally(function () { loading = null; });
    return loading;
  }

  /* Every token must hit a metafield value OR the product title. */
  function match(query, limit) {
    if (!index) return [];
    var tokens = query.trim().toLowerCase().split(' ').filter(function (t) { return t.length >= 2; });
    if (!tokens.length || query.trim().length < CONFIG.minChars) return [];
    var results = [];
    for (var i = 0; i < index.length; i++) {
      var prod = index[i];
      var values = prod.m || [];
      var title = String(prod.t || '').toLowerCase();
      var matchedValues = [];
      var allTokensHit = true;
      for (var t = 0; t < tokens.length; t++) {
        var hit = null;
        for (var v = 0; v < values.length; v++) {
          if (String(values[v]).toLowerCase().indexOf(tokens[t]) !== -1) {
            hit = values[v];
            break;
          }
        }
        if (hit) {
          if (matchedValues.indexOf(hit) === -1) matchedValues.push(hit);
        } else if (title.indexOf(tokens[t]) === -1) {
          allTokensHit = false;
          break;
        }
      }
      if (allTokensHit) {
        results.push({ p: prod, matched: matchedValues, score: (prod.av ? 100000 : 0) + (title.indexOf(tokens[0]) !== -1 ? 10000 : 0) + (prod.rc || 0) });
      }
    }
    results.sort(function (a, b) { return b.score - a.score; });
    return limit ? results.slice(0, limit) : results;
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = String(str == null ? '' : str);
    return d.innerHTML;
  }

  function starsHtml(prod) {
    if (!prod.rc || !prod.r) return '';
    var pct = Math.max(0, Math.min(100, prod.r * 20));
    return '<span class="jalu-rating" role="img" aria-label="Rated ' + prod.r + ' out of 5 stars from ' + prod.rc + ' reviews">' +
      '<span class="jalu-rating__stars" aria-hidden="true">' +
        '<span class="jalu-rating__base">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
        '<span class="jalu-rating__fill" style="width:' + pct + '%">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
      '</span>' +
      '<span class="jalu-rating__count">(' + prod.rc + ')</span>' +
    '</span>';
  }

  /* Cap matched values: max 3 shown, each trimmed to ~40 chars on a
     word boundary, so long metafield sentences can't blow out cards. */
  function matchLine(res) {
    if (!res.matched.length) return '';
    var vals = res.matched.slice(0, 3).map(function (v) {
      v = String(v);
      return v.length > 40 ? v.slice(0, 40).replace(/\s+\S*$/, '') + '…' : v;
    });
    return '<span class="jalu-smart-suggest__match">Matched: <b>' + esc(vals.join(', ')) + '</b></span>';
  }

  function rowHtml(res) {
    var prod = res.p;
    var img = prod.img
      ? '<img class="jalu-smart-suggest__img" loading="lazy" src="' + esc(prod.img) + '" alt="">'
      : '<span class="jalu-smart-suggest__img"></span>';
    var inspLine = prod.insp
      ? '<span class="jalu-smart-suggest__insp"><i>Inspired by</i> ' + esc(prod.insp) + '</span>'
      : '';
    return '<a class="jalu-smart-suggest__item" href="' + esc(prod.u) + '"' + (prod.av ? '' : ' data-soldout') + '>' +
      img +
      '<span class="jalu-smart-suggest__info">' +
        '<span class="jalu-smart-suggest__name">' + esc(prod.t) + '</span>' +
        starsHtml(prod) +
        inspLine +
        matchLine(res) +
      '</span>' +
      '<span class="jalu-smart-suggest__price">' + esc(prod.p) + (prod.av ? '' : ' &middot; Sold out') + '</span>' +
    '</a>';
  }

  function cardHtml(res) {
    var prod = res.p;
    var img = prod.img
      ? '<img class="jalu-smart-card__img" loading="lazy" src="' + esc(prod.img) + '" alt="">'
      : '<span class="jalu-smart-card__img"></span>';
    var inspBox = prod.insp
      ? '<span class="jalu-inspired"><span class="jalu-inspired__label">Inspired by</span><span class="jalu-inspired__value">' + esc(prod.insp) + '</span></span>'
      : '';
    return '<a class="product-card jalu-smart-card" href="' + esc(prod.u) + '"' + (prod.av ? '' : ' data-soldout') + '>' +
      img +
      '<span class="jalu-smart-card__name">' + esc(prod.t) + '</span>' +
      starsHtml(prod) +
      inspBox +
      matchLine(res) +
      '<span class="jalu-smart-card__price">' + esc(prod.p) + (prod.av ? '' : ' &middot; Sold out') + '</span>' +
    '</a>';
  }

  function render(container, results, titleText, asGrid) {
    if (!results.length) {
      container.removeAttribute('data-has-results');
      container.innerHTML = '';
      return;
    }
    var html = '<span class="jalu-smart-suggest__title">' + esc(titleText) + '</span>';
    if (asGrid) {
      html += '<div class="jalu-smart-suggest__grid">';
      results.forEach(function (res) { html += cardHtml(res); });
      html += '</div>';
    } else {
      results.forEach(function (res) { html += rowHtml(res); });
    }
    container.innerHTML = html;
    container.setAttribute('data-has-results', '');
  }

  function containerFor(input) {
    var form = input.closest('form') || input.parentElement;
    var c = form.querySelector(':scope > .jalu-smart-suggest');
    if (!c) {
      c = document.createElement('div');
      c.className = 'jalu-smart-suggest';
      form.appendChild(c);
    }
    return c;
  }

  function isSearchInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    return el.type === 'search' || el.name === 'q';
  }

  var debounceTimer = null;

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!isSearchInput(input)) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      loadIndex().then(function () {
        render(containerFor(input), match(input.value, CONFIG.maxDropdown), 'Matched by scent profile', false);
      });
    }, 180);
  });

  document.addEventListener('focusin', function (e) {
    if (isSearchInput(e.target)) loadIndex();
  }, { passive: true });

  /* Search results page: our grid becomes the results view.
     We keep only the section containing the search input; every
     other section (the native results grid) is hidden. If we have
     no matches, nothing is touched and native results display. */
  function initSearchPage() {
    if (window.location.pathname.indexOf('/search') === -1) return;
    var q = new URLSearchParams(window.location.search).get('q');
    if (!q) return;
    loadIndex().then(function () {
      var results = match(q, 0); // no cap
      if (!results.length) return; // native results stay visible
      var main = document.getElementById('MainContent');
      if (!main) return;

      var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
      if (!sections.length) {
        sections = Array.prototype.slice.call(main.children);
      }
      var headerSection = null;
      sections.forEach(function (s) {
        if (s.querySelector && s.querySelector('input[type="search"], input[name="q"]')) {
          headerSection = s;
        } else {
          s.style.display = 'none';
        }
      });

      var banner = document.createElement('div');
      banner.className = 'jalu-smart-suggest jalu-smart-suggest--page';
      if (headerSection) {
        headerSection.insertAdjacentElement('afterend', banner);
      } else {
        main.insertBefore(banner, main.firstChild);
      }
      render(banner, results, results.length + ' fragrances matched', true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }
})();